import { AppConfigStructure } from './config';

const isRunningInCI = Boolean(process.env['GITHUB_ACTIONS']);
const productionConfig: AppConfigStructure = {
  name: 'production',

  intercom: {
    isOn: true,
  },
  sentry: {
    // dont send sentry events when running in github actions because it means the errors come from tests and we dont want to track them
    isOn: !isRunningInCI && !process.env.VITEST,
    DSN: 'https://0cd6aef08375436998965905c89961c9@sentry.io/1280773',
  },

  eventTracker: {
    isOn: !process.env.VITEST,
  },
  splitFeatureFlagSystem: {
    isOn: true,
    key: 'qid0n2alundckn8ff8239v19ar17op8qt0al',
  },

  identityEndpointSlug: 'identity',

  fullStory: {
    isOn: true,
  },

  features: {},
};

export default productionConfig;
